export default "__VITE_ASSET__910afdd8__"